import React from "react";
import {TableRow} from "../table/table-row";

export const ScrollableTableRow = ({children, className, ...rest}) => {

  const containerProps = {
    className,
    ...rest
  }
  return (<TableRow {...containerProps}>
      {children}
    </TableRow>
  )
};